import { CloudinaryAsset } from '../../types/schemas/objects/CloudinaryAsset';
import { SanityImageAsset } from '../../types/schemas/objects/SanityImageAsset';

export const getNextImageSrc = (asset: CloudinaryAsset | SanityImageAsset | string): string => {
	if (typeof asset === 'string') {
		// eslint-disable-next-line no-console
		console.warn(`${asset} wasn't migrated to Cloudinary`);
		return asset;
	}
	if (asset?._type === 'cloudinary.asset') {
		return asset.public_id;
	}
	if (asset?._type === 'sanity.imageAsset') {
		return asset.url || '';
	}
	return '';
};
